import $ from "jquery";
import bootstrap from 'bootstrap';

import "@core/alpine-app.js"
import "@core/component/struts-integration/next-htmx/index.js"
import "@core/component/struts-integration/next-htmx/next-htmx-bs5-ext.js"
import "@core/component/struts-integration/next-link.js"
import '@core/component/html-preview/html-preview.js';
import "@core/css.js"

window.$ = $;
window.jQuery = $;

htmx.config.refreshOnHistoryMiss = true;

